import { render, staticRenderFns } from "./EvaluatorView.vue?vue&type=template&id=0fb1a556&scoped=true"
import script from "./EvaluatorView.vue?vue&type=script&lang=js"
export * from "./EvaluatorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb1a556",
  null
  
)

export default component.exports